import React from 'react';
import DrawingOptions from 'components/quote_builder_widget/DrawingOptions';

const QuoteBuilderForm = ({ theme, id, setId, drawing, unitOption = 'both' }) => {
  return (
    <div>
      <DrawingOptions
        theme={theme}
        id={id}
        setId={setId}
        drawing={drawing}
        unitOption={unitOption}
      />
    </div>
  );
};

export default QuoteBuilderForm;
